import {Concept} from 'types';
import type {TypedSchema} from 'schemaDefinition/types';
import {Separator} from 'schemaDefinition/types';
import type {Prize} from 'services/prizes/types';
import {isFeatureEnabled} from 'configuration';
import {CodeListRef} from '../references';

type PrizeSchema = TypedSchema<Prize>;

export const prizeSchema: PrizeSchema = {
  name: 'prize',
  key: 'prize',
  parts: [
    {
      name: 'name',
      type: 'text',
      required: true,
    },
    {
      name: 'presenter',
      type: 'text',
      required: true,
    },
    ...((isFeatureEnabled('prizeExtraFields')
      ? [
          {
            name: 'website',
            key: 'website',
            type: 'text',
          },
          {
            name: 'month',
            type: 'codelist',
            codelistId: 'MONTH',
            key: 'prizeMonth',
            cardinality: 'single',
          },
        ]
      : []) as PrizeSchema['parts']),
    [
      {
        name: 'startYear',
        type: 'year',
      },
      {
        name: 'endYear',
        type: 'year',
      },
    ],
    ...((isFeatureEnabled('prizeExtraFields')
      ? [
          {
            name: 'about',
            key: 'prizeAbout',
            type: 'textarea',
          },
        ]
      : []) as PrizeSchema['parts']),
    Separator('line', 'line'),
    {
      name: 'internalComment',
      key: 'internalComments',
      type: 'textarea',
    },
    Separator('line', 'line'),
    {
      type: 'schema',
      name: 'winners',
      key: 'winners',
      cardinality: 'multiple',
      parts: [
        [
          {
            name: 'year',
            type: 'year',
            required: true,
          },
          {
            name: 'type',
            type: 'codelist',
            key: 'winner.type',
            codelistId: 'PRIZE_TYPE',
            required: true,
          },
          {
            type: 'expand',
            role: 'isTypeNone',
            when: [
              {
                condition: [
                  {
                    $not: {$eq: [{$ref: ':type'}, CodeListRef.PRIZE_TYPE.None]},
                    default: true,
                  },
                ],
                parts: [
                  [
                    {
                      type: 'linkedAgent',
                      name: 'agent',
                      cardinality: 'single',
                      entityRole: 'dummy',
                      entitySubtypes: [Concept.person],
                      roleCodelistId: 'DUMMY',
                      required: false,
                      disableDirectEdit: true,
                    },
                    {
                      type: 'expand',
                      role: 'work-link',
                      when: [
                        {
                          condition: [
                            {
                              $includes: {
                                arg1: {$ref: ':type'},
                                arg2: [
                                  CodeListRef.PRIZE_TYPE.Author,
                                  CodeListRef.PRIZE_TYPE.Illustrator,
                                  CodeListRef.PRIZE_TYPE.Narrator,
                                  CodeListRef.PRIZE_TYPE.Translator,
                                ],
                              },
                              default: false,
                            },
                          ],
                          parts: [
                            {
                              type: 'linkedLiterary',
                              name: 'work',
                              // key: 'winner.work',
                              cardinality: 'single',
                              roleCodelistId: 'prize.linkedRole',
                              linkRole: 'awardedFor.work',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                ],
              },
            ],
          },
        ],
      ],
    },
  ],
};
